import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import TemplateAnalytics from "../../components/Template/Template Analytics/TemplateAnalytics";
import { useDispatch, useSelector } from "react-redux";
import { setBreadcrumbs } from "../../redux/Slice/Dashboard/leftNavSlice";
import { updateSelectedTemplate, fetchTemplates } from "../../redux/Slice/Templates/templateSlice";
import { fetchUserPermissions } from "../../redux/Slice/User/userDetailsSlice";
import AuthView from "../../utils/AuthView";

const TemplateAnalyticsPage = () => {
  const { templateId } = useParams();
  const dispatch = useDispatch();
  const templates = useSelector((state) => state.template.templates);
  const { userPermissions } = useSelector((state) => state.userDetails);

  // Check if user has permission to view templates
  const canViewTemplates = userPermissions?.permissions?.Templates?.View || false;

  useEffect(() => {
    dispatch(fetchUserPermissions());
    dispatch(setBreadcrumbs(["Templates", "Analytics"]));
  }, [dispatch]);

  // On mount or when templateId/Redux templates change, set selectedTemplate
  useEffect(() => {
    if (!templateId) return;
    if (templates && templates.length > 0) {
      const found = templates.find(t => t.name === templateId);
      if (found) {
        dispatch(updateSelectedTemplate(found));
      }
    } else {
      // Fetch templates if not loaded
      dispatch(fetchTemplates());
    }
  }, [templateId, templates, dispatch]);

  // Default to last 7 days
  const now = Math.floor(Date.now() / 1000);
  const sevenDaysAgo = now - 7 * 24 * 60 * 60;

  // If user doesn't have permission to view templates
  if (!canViewTemplates) {
    return <AuthView />;
  }

  return (
    <TemplateAnalytics
      templateId={templateId}
      start={sevenDaysAgo}
      end={now}
      templateName={templateId}
    />
  );
};

export default TemplateAnalyticsPage; 